import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import './css/included-course-details.scss';
import { fetch_course, HANDLE_COURSE_STATUS } from '../store/modules/collection';
import { fetch_course_included_section } from '../store/modules/course';

export const IncludedCourseDetails = function ({ course, index, onDelete, isParentCourse = false, isReadOnly = false, showHeader = true }) {
  const [inputValue, setInputValue] = useState(course.moduleId || '');
  const items = isParentCourse ? (isReadOnly ? ['No.', 'Course ID', 'Title'] : ['Course ID', 'Title', 'Duration']) : ['No.', 'Course ID', 'Title', 'Duration'];
  const courses = useSelector((state) => state.collection.courses);
  const { coursesIncluded } = useSelector((state) => state.course)
  const courseList = isParentCourse ? coursesIncluded : courses;
  const dispatch = useDispatch();

  function handleDelete(ev) {
    /* I have added a nice animation to highlight the deleted course */
    const div = ev.target.parentNode;
    div.style.height = '0';
    div.style.animation = '.2s linear 2 flash';
    setTimeout(() => {
      onDelete(course.moduleId);
    }, 700);
  }

  function handleInputChange(ev) {
    const moduleId = ev.target.value;
    setInputValue(moduleId);
    dispatch(HANDLE_COURSE_STATUS({ key: 'moduleId', value: moduleId }));
  }

  function handleSubmitIdCollection(ev) {
    const courseId = ev.target.value;
    if (ev.key === 'Enter' && !course.title) {
      dispatch(fetch_course({ courseId }));
    }
  }

  function handleSubmitIdCourse(ev) {
    const courseId = inputValue;
    if (ev.key === 'Enter') {
      dispatch(fetch_course_included_section({ courseId }));
    }
  }

  return (
    <div className={`included-course-details ${!isParentCourse ? 'flex' : isReadOnly ? 'read-only-row' : 'h-course'}`}>
      {!isParentCourse ? <div>
        <ul className="flex flex-auto">
          {items.map((val) => (
            <li key={val}>{val}</li>
          ))}
        </ul>
        <ul className="flex" cy={`courses-included-list-${index}`}>
          <li>{index + 1}</li>
          <li>
            <input
              className="wh100"
              value={course.moduleId}
              onChange={() => { }}
              onKeyUp={(ev) => handleSubmitIdCollection(ev)}
              type="text"
            />
          </li>
          <li className="course-title">
            <span>{course.isFetching ? 'Fetching course ...' : courseList[index]?.title}</span>
            {course.isError && <span>Course id not found</span>}
            {course.isDuplicated && <span>Course duplicate</span>}
          </li>
          <li>
            <span>{courseList[index]?.duration}</span>
          </li>
        </ul>
      </div> : <div>
        {showHeader && (
          <ul className={`flex width-full-list flex-auto${isReadOnly ? ' read-only' : ''}`}>
            {items.map((val) => (
              <li key={val}><b>{val}</b></li>
            ))}
          </ul>
        )}
        <ul className={`flex width-full-list${isReadOnly ? ' read-only' : ''}`} cy={`courses-included-list-${index}`}>
          {isReadOnly && <li>{index + 1}</li>}
          <li>
            <input
              className="wh100"
              style={{ border: '1px solid #CCCDCD', backgroundColor: isReadOnly ? '#f2f2f2' : undefined }}
              value={isReadOnly ? (course.moduleId || '') : inputValue}
              onChange={isReadOnly ? () => {} : handleInputChange}
              onKeyUp={isReadOnly ? undefined : (ev) => handleSubmitIdCourse(ev)}
              disabled={isReadOnly}
              type="text"
            />
          </li>
          <li className="course-title">
            <span>{isReadOnly ? (course.title || '') : (course.isFetching ? 'Fetching course ...' : courseList[index]?.title)}</span>
            {!isReadOnly && course.isError && !course.isFetching && !courseList[index]?.title && <span>Course id not found</span>}
          </li>
          {!isReadOnly && (
            <li>
              <span>{courseList[index]?.duration}</span>
            </li>
          )}
        </ul>
      </div>

      }
      {!isParentCourse && <button className="bg-transparent no-border" onClick={handleDelete}>
        Delete
      </button>}
    </div>
  );
};
